<template>
    <div>
        <v-container>
            <v-toolbar dense flat color="transparent">
                <v-toolbar-title class="font-weight-bold">Department Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="onDelete()" color="error" text class="ml-2">Delete</v-btn>
                <v-btn @click="onSave()" color="primary" class="ml-2">Save</v-btn>
            </v-toolbar>
            <v-row>
                <v-col cols="4">
                    <v-form ref="editForm">
                        <v-card flat>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Name</div>
                                <v-text-field
                                    v-model="item.name"
                                    required
                                    :rules="[v => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-text-field>
                            </v-card-text>
                            <v-card-text class="pb-0">
                                <div class="subtitle-2">Email</div>
                                <v-combobox
                                    outlined
                                    multiple
                                    v-model="emailList"
                                    append-icon
                                    chips
                                    deletable-chips
                                    class="tag-input"
                                ></v-combobox>
                            </v-card-text>
                            <v-card-text>
                                <div class="subtitle-2">Description</div>
                                <v-textarea
                                    v-model="item.description"
                                    required
                                    :rules="[v => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                ></v-textarea>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-col>
                <v-col cols="4">
                    <v-card flat>
                        <v-card-text class="pb-0">
                            <div class="subtitle-2">Created At</div>
                            <div
                                class="body-1 my-2"
                            >{{ $moment(item.created_at).format('DD-MM-YYYY HH:mm:ss') }}</div>
                        </v-card-text>
                        <v-card-text class="pb-0">
                            <div class="subtitle-2">Updated At</div>
                            <div
                                class="body-1 my-2"
                            >{{ $moment(item.updated_at).format('DD-MM-YYYY HH:mm:ss') }}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modelPath: "departments",
            select: null,
            emailList: [],
            item: {
                name: "",
                emails: [],
                description: "",
                created_at: null,
                updated_at: null
            }
        };
    },
    created() {
        this.getItemDetails().then(data => {
            this.item = data.item;
            this.emailList = data.item.emails.map(a => a.email);
        });
    },
    watch: {
        emailList: function(val, prev) {
            if (val.length === prev.length) return;
            this.emailList = val.filter(a =>
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    a
                )
            );
            this.item.emails = this.emailList.map(a => {
                return { email: a };
            });
        }
    },
    methods: {
        onSave: function() {
            if (this.$refs.editForm.validate()) {
                //TODO :- Perform action if the form is validated

                this.updateItem().then(res => {
                    if ((res.status = 200)) {
                        this.item = res.item;
                    }
                });
            }
        },
        onDelete: function() {
            if (this.$refs.editForm.validate()) {
                //TODO :- Perform action if the form is validated

                this.deleteItem().then(res => {
                    if ((res.status = 204)) {
                        this.$router.push("/settings/department");
                    }
                });
            }
        },
        updateTags() {
            this.$nextTick(() => {
                this.select.push(
                    ...(this.search ? this.search.split(",") : [])
                );
                this.$nextTick(() => {
                    this.search = "";
                });
            });
        },
        getItemDetails: function() {
            return new Promise(resolve => {
                this.$http({
                    method: "get",
                    url: `/${this.modelPath}/${this.$route.params.id}`
                }).then(function(response) {
                    console.log(response.data);
                    let item = response.data;
                    resolve({
                        item
                    });
                });
            });
        },
        updateItem: function() {
            return new Promise(resolve => {
                this.$http({
                    method: "put",
                    url: `/${this.modelPath}/${this.$route.params.id}`,
                    data: this.item
                }).then(function(response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item
                    });
                });
            });
        },
        deleteItem: function() {
            return new Promise(resolve => {
                this.$http({
                    method: "delete",
                    url: `/${this.modelPath}/${this.$route.params.id}`
                }).then(function(response) {
                    console.log(response.data);
                    let status = response.status;
                    let item = response.data;
                    resolve({
                        status,
                        item
                    });
                });
            });
        }
    }
};
</script>
